class quickMap {
    constructor(options) {
        this.ol = options.ol;
        this.turf = options.turf;
        this.target = options.target;
        this.compass = options.compass;
        this.compassDegrees = 0;
        this.enableRotation = options.enableRotation ?? true;
        this.logo = options.logo;
        this.newtinHost = options.newtinHost;
        this.startLongLat = options.startLongLat ?? [0, 0];
        this.startZoom = options.startZoom ?? 0;
        this.maxZoom = options.maxZoom ?? 20;
        this.states = this.getFeatureData(options.extraData.states);
        this.counties = this.getFeatureData(options.extraData.counties);
        this.declutter = options.declutter ?? false;
        this.blink = options.blink ?? true;
        this.blinkInterval = options.blinkInterval ?? 500;
        this.editColor = options.editColor ?? [0, 0, 0];
        this.drawType = options.drawType ?? 'Polygon';
        this.drawBuffer = options.drawBuffer ?? 0;
        this.drawText = options.drawText ?? '';
        this.merge = options.merge ?? false;
        this.complex = options.complex ?? false;
        this.msgboxTimeout = options.msgboxTimeout ?? 1500;
        this.mapHeightVh = options.mapHeightVh ?? undefined;
        this.mapWidthVh = options.mapWidthVh ?? undefined;

        this.defaultStyles = {
            'Point': new this.ol.style.Style({
                text: new this.ol.style.Text({ text: '', font: 'bold 12px Calibri,sans-serif', stroke: new this.ol.style.Stroke({ color: [255, 255, 255, 1], width: 3 }), fill: new this.ol.style.Fill({ color: [[0, 0, 0, 1]] }), offsetY: -15 }),
                image: new this.ol.style.Circle({ stroke: new this.ol.style.Stroke({ color: [[0, 0, 0, 1]], width: 2 }), fill: new this.ol.style.Fill({ color: [255, 255, 255, 1] }), radius: 5 }),
            }),
            'LineString': new this.ol.style.Style({
                text: new this.ol.style.Text({ text: '', font: 'bold 12px Calibri,sans-serif', stroke: new this.ol.style.Stroke({ color: [255, 255, 255, 1], width: 3 }), fill: new this.ol.style.Fill({ color: [[0, 0, 0, 1]] }), offsetY: -15 }),
                stroke: new this.ol.style.Stroke({ color: [[0, 0, 0, 1]], width: 2 }),
            }),
            'Polygon': new this.ol.style.Style({
                text: new this.ol.style.Text({ text: '', font: 'bold 12px Calibri,sans-serif', stroke: new this.ol.style.Stroke({ color: [255, 255, 255, 1], width: 3 }), fill: new this.ol.style.Fill({ color: [[0, 0, 0, 1]] }), offsetY: -15 }),
                stroke: new this.ol.style.Stroke({ color: [[0, 0, 0, 1]], width: 2 }),
                fill: new this.ol.style.Fill({ color: [0, 0, 0, 0.2] }),
            }),
        };

        if (this.mapHeightVh) {
            document.getElementById(this.target).style.height = this.mapHeightVh + 'vh';
        }
        if (this.mapWidthVh) {
            document.getElementById(this.target).style.width = this.mapWidthVh + 'vw';
        }

        this.layers = this.setupLayers();
        this.map = new this.ol.Map({
            target: this.target,
            layers: this.layers,
            view: new this.ol.View({
                center: this.ol.proj.fromLonLat(this.startLongLat),
                zoom: this.startZoom,
                maxZoom: this.maxZoom,
                enableRotation: this.enableRotation,
            }),
        });

        this.setupControls();
        this.buttonsGroupActive = true;

        this.map.on('singleclick', (evt) => this.onSingleClick(evt));
        this.map.on('moveend', () => {
            this.dispatchEvent('qmolMoveEnd', { type: 'movend' });
            this.getNewtin();
        });

        setInterval(() => {
            this.blinkShow();
        }, this.blinkInterval);
    }

    set showLayerSelect(show) {
        this.selLayers.style.display = show ? 'block' : 'none';
    }
    set showCompass(show) {
        this.imgCompass.style.display = show ? 'block' : 'none';
    }
    set showToggleFullScreen(show) {
        this.btnToggleFullscreen.style.display = show ? 'block' : 'none';
    }
    set showZoomToAll(show) {
        this.btnZoomAll.style.display = show ? 'block' : 'none';
    }
    set showDraw(show) {
        this.btnDraw.style.display = show ? 'block' : 'none';
    }
    set showEdit(show) {
        this.btnEdit.style.display = show ? 'block' : 'none';
    }
    set showDelete(show) {
        this.btnDelete.style.display = show ? 'block' : 'none';
    }
    set showMeasure(show) {
        this.btnMeasure.style.display = show ? 'block' : 'none';
    }
    set showBullseye(show) {
        this.btnBullseye.style.display = show ? 'block' : 'none';
    }
    set showIdentify(show) {
        this.btnIdentify.style.display = show ? 'block' : 'none';
    }
    set showWeather(show) {
        this.btnWeather.style.display = show ? 'block' : 'none';
    }
    set showScaleBar(show) {
        this.scaleBar.style.display = show ? 'block' : 'none';
    }
    set showLongLat(show) {
        document.querySelector('#map').querySelector('.ol-latlong').style.display = show ? 'block' : 'none';
    }
    set showLogo(show) {
        this.imgLogo.style.display = show ? 'block' : 'none';
    }
    set showClear(show) {
        this.btnClear.style.display = show ? 'block' : 'none';
    }
    set setDrawType(type) {
        this.drawType = type;
        if (this.btnDraw.className.indexOf('ol-toggled') > -1) {
            this.removeInteractions();
            this.toggleButtonsOn();
        }
    }

    setupLayers() {
        const layers = [];
        const gotNewtin = this.newtinHost && this.newtinHost.length > 0;

        if (gotNewtin > 0) {
            layers.push(
                new this.ol.layer.Image({
                    visible: true,
                    name: 'Newtin Streets',
                    isBase: true,
                    isNewtin: true,
                    isAerial: false,
                }),
                new this.ol.layer.Image({
                    visible: false,
                    name: 'Newtin Aerial',
                    isBase: true,
                    isNewtin: true,
                    isAerial: true,
                })
            );
        }

        layers.push(
            new this.ol.layer.Tile({
                visible: !gotNewtin,
                name: 'OpenStreetMap',
                isBase: true,
                source: new this.ol.source.OSM(),
            })
        );
        layers.push(
            new this.ol.layer.Tile({
                visible: false,
                name: 'USGS Aerial',
                isBase: true,
                source: new this.ol.source.XYZ({
                    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    crossOrigin: 'anonymous',
                    maxZoom: 18,
                }),
            })
        );
        layers.push(
            new this.ol.layer.Tile({
                visible: false,
                name: 'National Hybrid',
                isBase: true,
                source: new this.ol.source.XYZ({
                    url: 'https://basemap.nationalmap.gov/ArcGIS/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}',
                    crossOrigin: 'anonymous',
                    maxZoom: 16,
                }),
            })
        );
        layers.push(
            new this.ol.layer.Tile({
                visible: false,
                name: 'World Topo',
                isBase: true,
                source: new this.ol.source.XYZ({
                    url: 'http://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
                    maxZoom: 18,
                }),
            })
        );
        layers.push(
            new this.ol.layer.Tile({
                visible: false,
                name: 'USGS Topo',
                isBase: true,
                source: new this.ol.source.XYZ({
                    url: 'http://caltopo.s3.amazonaws.com/topo/{z}/{x}/{y}.png',
                    crossOrigin: 'anonymous',
                    maxZoom: 16,
                }),
            })
        );
        layers.push(
            new this.ol.layer.Tile({
                visible: false,
                name: 'Radar',
                isBase: true,
                isTransparent: true,
                source: new this.ol.source.TileWMS({
                    url: 'https://mapservices.weather.noaa.gov:443/eventdriven/services/radar/radar_base_reflectivity/MapServer/WmsServer',
                    crossOrigin: 'anonymous',
                    params: {
                        'LAYERS': '1',
                    },
                }),
                opacity: 0.6,
            })
        );
        layers.push(
            new this.ol.layer.Tile({
                visible: false,
                name: 'none',
                isBase: true,
            })
        );

        this.image = new this.ol.layer.Image({
            visible: true,
            name: 'image',
            isBase: false,
        });
        layers.push(this.image);

        this.show = new this.ol.layer.VectorImage({
            name: 'show',
            source: new this.ol.source.Vector(),
            declutter: this.declutter,
            style: (feature, resolution) => this.getStyle(feature, resolution),
        });
        layers.push(this.show);

        this.edit = new this.ol.layer.VectorImage({
            name: 'edit',
            source: new this.ol.source.Vector(),
            style: (feature, resolution) => this.getStyle(feature, resolution),
        });
        layers.push(this.edit);

        this.measure = new this.ol.layer.VectorImage({
            name: 'measure',
            source: new this.ol.source.Vector(),
            style: (feature) => this.measureStyle(feature),
        });
        layers.push(this.measure);

        this.bullseye = new this.ol.layer.VectorImage({
            name: 'bullseye',
            source: new this.ol.source.Vector(),
        });
        layers.push(this.bullseye);

        return layers;
    }

    setupControls() {
        this.selLayers = document.createElement('select');
        this.selLayers.title = 'Switch map layers';
        this.selLayers.className = 'ol-switcher';
        for (const layer of this.layers) {
            if (layer.get('isBase')) {
                const option = document.createElement('option');
                option.text = layer.getProperties().name;
                this.selLayers.appendChild(option);
            }
        }
        this.selLayers.onchange = () => this.onChangeSelLayers();
        this.map.addControl(
            new this.ol.control.Control({
                element: this.selLayers,
            })
        );

        this.imgCompass = document.createElement('img');
        this.imgCompass.title = 'Compass rose';
        this.imgCompass.className = 'ol-compass';
        this.imgCompass.src = this.compass;
        if (this.enableRotation) {
            this.imgCompass.ondblclick = () => this.onRotationReset();
            this.imgCompass.onclick = () => this.onRotationIncrement();
        }
        this.imgCompass.onerror = () => {
            this.imgCompass.style.display = 'none';
        };
        this.map.addControl(
            new this.ol.control.Control({
                element: this.imgCompass,
            })
        );

        this.map.getView().on('change:rotation', () => {
            const radians = this.map.getView().getRotation();
            this.compassDegrees = (radians * 180) / Math.PI;
            document.getElementsByClassName('ol-compass')[1].style.transform = `rotate(${radians}rad)`;
        });

        this.imgLogo = document.createElement('img');
        this.imgLogo.className = 'ol-logo';
        this.imgLogo.src = this.logo;
        this.imgLogo.onerror = () => {
            this.imgLogo.style.display = 'none';
        };
        this.map.addControl(
            new this.ol.control.Control({
                element: this.imgLogo,
            })
        );

        this.map.addControl(
            new this.ol.control.ScaleLine({
                bar: false,
                units: 'us',
                className: 'ol-scale-line',
            })
        );
        this.scaleBar = document.querySelector('#' + this.target).querySelector('.ol-scale-line');
        this.scaleBar.title = 'Scale in feet/miles';

        this.divLatLong = document.createElement('div');
        this.map.addControl(
            new this.ol.control.Control({
                element: this.divLatLong,
            })
        );

        this.mousePositionControl = new this.ol.control.MousePosition({
            className: 'ol-latlong',
            target: this.divLatlong,
            coordinateFormat: this.ol.coordinate.createStringXY(5),
            projection: 'EPSG:4326',
            undefinedHTML: '',
        });
        this.map.controls.extend([this.mousePositionControl]);
        const divOlLatLong = document.querySelector('#' + this.target).querySelector('.ol-latlong');
        divOlLatLong.title = 'Longitude/Latitude in decimal degrees for current mouse position';

        this.divPopup = document.createElement('div');
        this.divPopup.className = 'ol-popup';
        this.map.addControl(
            new this.ol.control.Control({
                element: this.divPopup,
            })
        );
        this.divPopupOverlay = new this.ol.Overlay({
            element: this.divPopup,
            closeBox: true,
        });
        this.map.addOverlay(this.divPopupOverlay);

        this.msgbox = document.createElement('div');
        this.msgbox.className = 'ol-msgbox';
        this.map.addControl(
            new this.ol.control.Control({
                element: this.msgbox,
            })
        );

        const divOlZoom = document.querySelector('#' + this.target).querySelector('.ol-zoom');

        this.btnToggleFullscreen = document.createElement('button');
        this.btnToggleFullscreen.title = 'Toggle Fullscreen';
        this.btnToggleFullscreen.className = 'ol-btntogglefullscreen';
        this.btnToggleFullscreen.onclick = () => this.toggleFullscreen();
        divOlZoom.appendChild(this.btnToggleFullscreen);

        this.btnZoomAll = document.createElement('button');
        this.btnZoomAll.title = 'Zoom to all Features';
        this.btnZoomAll.className = 'ol-btnzoomall';
        this.btnZoomAll.onclick = () => this.zoomToAll();
        divOlZoom.appendChild(this.btnZoomAll);

        this.btnDraw = document.createElement('button');
        this.btnDraw.title = 'Draw';
        this.btnDraw.className = 'ol-toggle-button-group ol-btndraw';
        this.btnDraw.onclick = () => this.startDraw();
        divOlZoom.appendChild(this.btnDraw);

        this.btnEdit = document.createElement('button');
        this.btnEdit.title = 'Edit';
        this.btnEdit.className = 'ol-toggle-button-group ol-btnedit';
        this.btnEdit.onclick = () => this.startEdit();
        divOlZoom.appendChild(this.btnEdit);

        this.btnDelete = document.createElement('button');
        this.btnDelete.title = 'Delete';
        this.btnDelete.className = 'ol-toggle-button-group ol-btndelete';
        this.btnDelete.onclick = () => this.startDelete();
        divOlZoom.appendChild(this.btnDelete);

        this.btnMeasure = document.createElement('button');
        this.btnMeasure.title = 'Measure distance';
        this.btnMeasure.className = 'ol-toggle-button-group ol-btnmeasure';
        this.btnMeasure.onclick = () => this.startMeasure();
        divOlZoom.appendChild(this.btnMeasure);

        this.btnBullseye = document.createElement('button');
        this.btnBullseye.title = 'Bullseye (100ft & 1/4 mi)';
        this.btnBullseye.className = 'ol-toggle-button-group ol-btnbullseye';
        this.btnBullseye.onclick = () => this.startBullseye();
        divOlZoom.appendChild(this.btnBullseye);

        this.btnIdentify = document.createElement('button');
        this.btnIdentify.title = 'Identify';
        this.btnIdentify.className = 'ol-toggle-button-group ol-btnidentify';
        this.btnIdentify.onclick = () => this.startIdentify();
        divOlZoom.appendChild(this.btnIdentify);

        this.btnWeather = document.createElement('button');
        this.btnWeather.title = 'Weather Info';
        this.btnWeather.className = 'ol-toggle-button-group ol-btnweather';
        this.btnWeather.onclick = () => this.startWeather();
        divOlZoom.appendChild(this.btnWeather);

        this.btnClear = document.createElement('button');
        this.btnClear.title = 'Clear';
        this.btnClear.className = 'ol-toggle-button-group ol-btnclear';
        this.btnClear.onclick = () => {
            const event = new CustomEvent('qmolClear', {
                detail: {
                    type: 'clear',
                },
            });
            document.dispatchEvent(event);
        };
        divOlZoom.appendChild(this.btnClear);
    }

    toggleFullscreen() {
        const isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) || (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) || (document.mozFullScreenElement && document.mozFullScreenElement !== null) || (document.msFullscreenElement && document.msFullscreenElement !== null);
        const docElm = document.getElementById(this.target);
        if (!isInFullScreen) {
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
            } else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen();
            } else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen();
            } else if (docElm.msRequestFullscreen) {
                docElm.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }

    onChangeSelLayers() {
        const layerName = this.selLayers.value;
        let transparent = false;
        this.map.getLayers().forEach((layer) => {
            if (layer.get('name') === layerName) {
                transparent = layer.get('isTransparent');
            }
        });
        this.map.getLayers().forEach((layer) => {
            if (layer.get('name') === layerName) {
                layer.setVisible(true);
            } else {
                if (!transparent) {
                    if (layer.get('isBase')) {
                        layer.setVisible(false);
                    }
                }
            }
        });
        this.getNewtin();
    }

    getNewtin() {
        let active;
        for (const layer of this.layers) {
            if (layer.get('visible')) {
                active = layer;
                break;
            }
        }
        if (!active.get('isNewtin')) return;

        const mapExtent = this.ol.proj.transformExtent(this.map.getView().calculateExtent(this.map.getSize()), 'EPSG:3857', 'EPSG:4326');

        const zoom = parseInt(this.distInMeters(mapExtent[0], mapExtent[3], mapExtent[0], mapExtent[1])) * 1.05;
        const canvas = document.getElementById(this.target);
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        const center = this.ol.proj.transform(this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');

        if (this.newtinLastCenter && this.newtinLastCenter[0] === center[0] && this.newtinLastCenter[1] === center[1]) {
            return;
        } else {
            this.newtinLastCenter = center;
        }

        const county = this.getCountyForLongLat(center);
        if (!county) return;

        fetch(this.newtinHost + '/mapping', {
            method: 'POST',
            mode: 'cors',
            body: `qmcmd;zoom;${width};${height};${county.STATE};${county.COUNTY.toUpperCase()};${center[1]};${center[0]};${zoom};${zoom < 30000 ? (active.get('isAerial') ? 'mrSidH' : '') : ''}`,
        })
            .then((response) => response.text())
            .then((data) => {
                const parts = data.split(';');
                const url = this.newtinHost + parts[1];
                const coords = parts[2].split(',');
                const extent = [coords[2], coords[1], coords[3], coords[0]];

                active.setSource(
                    new this.ol.source.ImageStatic({
                        url: url,
                        imageExtent: extent,
                        projection: 'EPSG:4326',
                        crossOrigin: 'anonymous',
                    })
                );
            })
            .catch((error) => console.error(error));
    }

    distInMeters(x1, y1, x2, y2) {
        return this.distInMiles(x1, y1, x2, y2) * 1609.344;
    }

    distInMiles(x1, y1, x2, y2) {
        var dx, dy;
        x1 = Math.abs(x1);
        y1 = Math.abs(y1);
        x2 = Math.abs(x2);
        y2 = Math.abs(y2);
        dx = Math.abs(x1 - x2) * Math.cos((((y1 + y2) / 2) * Math.PI) / 180) * 69.172;
        dy = Math.abs(y1 - y2) * (68.703 + (((y1 + y2) / 2) * 0.695) / 90);
        return Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
    }

    getCountyForLongLat(coord) {
        coord = this.ol.proj.fromLonLat(coord);
        for (const county of this.counties) {
            if (county.getGeometry().intersectsCoordinate(coord)) {
                return county.getProperties();
            }
        }
        return;
    }

    getFeatureData(data) {
        return new this.ol.format.GeoJSON().readFeatures(data, {
            featureProjection: 'EPSG:3857',
        });
    }

    zoomToState(st) {
        for (const state of this.states) {
            if (state.get('STATE') === st) {
                this.map.getView().fit(state.getGeometry(), {
                    padding: [50, 50, 50, 50],
                });
                break;
            }
        }
    }

    zoomToCounty(st, cnty) {
        for (const county of this.counties) {
            if (county.get('STATE') === st && county.get('COUNTY').toUpperCase() === cnty.toUpperCase()) {
                this.map.getView().fit(county.getGeometry(), {
                    padding: [50, 50, 50, 50],
                });
                break;
            }
        }
    }

    zoomToFeatures(featureCollection) {
        if (featureCollection.length === 0) return;

        const features = new this.ol.format.GeoJSON().readFeatures(featureCollection, {
            featureProjection: 'EPSG:3857',
        });

        let extent;
        for (const feature of features) {
            if (extent === undefined) {
                extent = feature.getGeometry().getExtent();
            } else {
                extent = this.ol.extent.extend(extent, feature.getGeometry().getExtent());
            }
        }
        this.map.getView().fit(extent, { padding: [50, 50, 50, 50] });

        if (this.map.getView().getZoom() > this.maxzoom) {
            this.map.getView().setZoom(this.maxzoom);
        }
        this.getNewtin();
    }

    zoomToLongLat(longLat, zoomLevel) {
        this.map.getView().setCenter(this.ol.proj.fromLonLat(longLat));
        if (zoomLevel) this.map.getView().setZoom(zoomLevel);
    }

    zoomToAll() {
        let extent = this.ol.extent.createEmpty();
        this.ol.extent.extend(extent, this.show.getSource().getExtent());
        this.ol.extent.extend(extent, this.edit.getSource().getExtent());
        if (this.img) {
            this.ol.extent.extend(extent, this.img.getSource().getExtent());
        }
        if (extent[0] === Infinity) return;
        this.map.getView().fit(extent, { padding: [50, 50, 50, 50] });
        this.getNewtin();
        if (this.map.getView().getZoom() > this.maxzoom) {
            this.map.getView().setZoom(this.maxzoom);
        }
    }

    getStyle(feature, resolution) {
        if (this.blink && feature.get('hidden')) {
            return;
        }
        const style = feature.get('style');
        if (!style) {
            const geometryType = feature.getGeometry().getType();
            this.defaultStyles[geometryType].setText(feature.get('text'));
            return this.defaultStyles[geometryType];
        }
        if (typeof style === 'function') {
            return style(this.map.getView().getZoomForResolution(resolution));
        }
        return style;
    }

    addToShow(features) {
        if (features.features.length === 0) return;
        this.show.getSource().addFeatures(
            new this.ol.format.GeoJSON().readFeatures(features, {
                featureProjection: 'EPSG:3857',
            })
        );
    }

    getFromShow() {
        return new this.ol.format.GeoJSON().writeFeatures(this.show.getSource().getFeatures(), {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });
    }

    removeFromShow(property, value) {
        for (const feature of this.show.getSource().getFeatures()) {
            if (feature.get(property) === value) {
                this.show.getSource().removeFeature(feature);
            }
        }
    }

    zoomToShow() {
        if (this.show.getSource().getFeatures().length === 0) return;
        this.map.getView().fit(this.show.getSource().getExtent(), {
            padding: [50, 50, 50, 50],
        });
        this.getNewtin();
        if (this.map.getView().getZoom() > this.maxzoom) {
            this.map.getView().setZoom(this.maxzoom);
        }
    }

    clearShow() {
        this.show.getSource().clear();
    }

    blinkShow() {
        if (!this.blink) return;
        var extent = this.map.getView().calculateExtent(this.map.getSize());
        const features = this.show.getSource().getFeaturesInExtent(extent);
        for (const feature of features) {
            if (feature.get('blink')) {
                feature.setProperties({ hidden: !feature.get('hidden') });
            }
        }
    }

    toggleButtonsOn() {
        this.buttonsGroupActive = true;
        const buttons = document.querySelector('#' + this.target).querySelectorAll('.ol-toggle-button-group');
        for (const button of buttons) {
            button.disabled = false;
            button.className = button.className.replace(/ ol-toggled/g, '');
        }
    }

    toggleButtonsOff(exceptButton) {
        this.buttonsGroupActive = false;
        const buttons = document.querySelector('#' + this.target).querySelectorAll('.ol-toggle-button-group');
        for (const button of buttons) {
            if (button !== exceptButton) {
                button.disabled = true;
            }
        }
        exceptButton.className = exceptButton.className + ' ol-toggled';
    }

    startMeasure() {
        this.removeInteractions();
        if (!this.buttonsGroupActive) {
            this.toggleButtonsOn();
            return;
        } else {
            this.toggleButtonsOff(this.btnMeasure);
            this.measure.getSource().clear();
        }

        this.draw = new this.ol.interaction.Draw({
            source: this.measure.getSource(),
            type: 'LineString',
            style: (feature) => this.measureStyle(feature),
        });

        this.modify = new this.ol.interaction.Modify({
            source: this.measure.getSource(),
        });

        this.map.addInteraction(this.draw);
        this.map.addInteraction(this.modify);
    }

    clearMeasure() {
        this.measure.getSource().clear();
    }

    startDraw() {
        this.removeInteractions();
        if (!this.buttonsGroupActive) {
            this.toggleButtonsOn();
            return;
        } else {
            this.toggleButtonsOff(this.btnDraw);
        }

        this.draw = new this.ol.interaction.Draw({
            source: this.edit.getSource(),
            type: this.drawType,
            style: (feature) => this.measureStyle(feature),
        });

        this.snap = new this.ol.interaction.Snap({
            source: this.edit.getSource(),
        });

        this.map.addInteraction(this.draw);
        this.map.addInteraction(this.snap);
        this.draw.on('drawstart', (feature) => this.onDrawStart(feature));
        this.draw.on('drawend', (feature) => this.onEndDraw(feature));
    }
    onDrawStart() {
        this.editCountBeforeDraw = this.edit.getSource().getFeatures().length;
    }
    onEndDraw(feature) {
        setTimeout(() => {
            this.addToFeatures([feature.feature]);

            const event = new CustomEvent('qmolDraw', {
                detail: {
                    features: new this.ol.format.GeoJSON().writeFeaturesObject([feature.feature], {
                        dataProjection: 'EPSG:4326',
                        featureProjection: 'EPSG:3857',
                    }),
                    type: 'draw',
                },
            });
            document.dispatchEvent(event);
        }, 0);
    }

    addToFeatures(features) {
        let hasKinks;
        let hasHoles;
        let removeFeatures = [];
        let addFeatures = !this.btnEdit.disabled ? this.editFeatures : [];

        for (let feature of features) {
            if (!this.buttonsGroupActive && !this.btnDraw.disabled && this.drawBuffer > 0) {
                const buffered = this.bufferFeature(feature);
                feature.setGeometry(buffered.getGeometry());
            }

            if (feature.get('style')) {
                feature.setStyle(feature.get('style'));
            } else {
                feature.setStyle(
                    new this.ol.style.Style({
                        text: new this.ol.style.Text({
                            text: this.drawText,
                            font: 'bold 12px Calibri,sans-serif',
                            stroke: new this.ol.style.Stroke({
                                color: [255, 255, 255, 1],
                                width: 3,
                            }),
                            fill: new this.ol.style.Fill({
                                color: this.editColor.concat(1),
                            }),
                            offsetY: -15,
                        }),
                        stroke: new this.ol.style.Stroke({
                            color: this.editColor.concat(1),
                            width: 2,
                        }),
                        fill: new this.ol.style.Fill({
                            color: this.editColor.concat(0.2),
                        }),
                        image: new this.ol.style.Circle({
                            stroke: new this.ol.style.Stroke({
                                color: this.editColor.concat(1),
                                width: 2,
                            }),
                            fill: new this.ol.style.Fill({
                                color: this.editColor.concat(1),
                            }),
                            radius: 5,
                        }),
                    })
                );
            }

            if (this.merge) {
                this.originalFeature = this.edit.getSource().getFeatures()[0].clone();
                this.mergeEdits();
                const newFeature = this.edit.getSource().getFeatures()[0];
                if (this.hasKinks(newFeature)) {
                    hasKinks = true;
                    removeFeatures.push(feature);
                    if (this.editCountBeforeDraw > 0) addFeatures.push(this.originalFeature);
                }
                if (this.ringCount(newFeature) > 1) {
                    hasHoles = true;
                    removeFeatures.push(feature);
                    if (this.editCountBeforeDraw > 0) addFeatures.push(this.originalFeature);
                }
                feature = this.edit.getSource().getFeatures()[0];
            }

            const kinks = this.hasKinks(feature);
            const rings = this.ringCount(feature);

            if (!this.complex && kinks) hasKinks = true;
            if (!this.complex && rings > 1) hasHoles = true;
            removeFeatures.push(feature);

            if (feature) {
                feature.setProperties({
                    fid: feature.getProperties().fid ? feature.getProperties().fid : crypto.randomUUID(),
                    fips: this.getFipsForFeature(feature),
                    kinks: kinks,
                    rings: rings,
                });
            }
        }

        if (hasKinks || hasHoles) {
            this.showMsgbox(`<h2><center>No polygons with ${hasKinks ? 'kinks' : 'holes'}!</center></h2>`, this.msgboxTimeout, removeFeatures, addFeatures);
            return;
        }
    }

    showMsgbox(msg, timeout, removeFeatures, addFeatures) {
        this.msgbox.innerHTML = msg;
        this.msgbox.style.display = 'block';
        setTimeout(() => {
            if (removeFeatures) {
                for (const feature of removeFeatures) {
                    this.edit.getSource().removeFeature(feature);
                }
            }
            if (addFeatures) this.edit.getSource().addFeatures(addFeatures);
            this.msgbox.style.display = 'none';
        }, timeout);
    }

    mergeEdits() {
        const merged = this.mergeFeatures(this.edit.getSource());
        if (!merged) {
            this.msgbox.innerHTML = `<h2>No more than one polygon!</h2>`;
            this.msgbox.style.display = 'block';

            setTimeout(() => {
                this.msgbox.style.display = 'none';
            }, 1500);
            return;
        }
    }

    bufferFeature(feature, bufferSize, bufferSteps = 8) {
        if (bufferSize === 0) return feature;

        const geojson = new this.ol.format.GeoJSON().writeFeatureObject(feature, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });

        const buffered = this.turf.buffer(geojson, !bufferSize ? this.drawBuffer : bufferSize, {
            units: 'feet',
            steps: bufferSteps,
        });

        return new this.ol.format.GeoJSON().readFeature(buffered, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });
    }

    hasKinks(feature) {
        if (feature && feature.getGeometry().getType() !== 'Point') {
            return this.turf.kinks(
                new this.ol.format.GeoJSON().writeFeatureObject(feature, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: 'EPSG:3857',
                })
            ).features.length > 0
                ? true
                : false;
        }
        return false;
    }

    ringCount(feature) {
        return feature && feature.getGeometry().getType() === 'Polygon' ? feature.getGeometry().getLinearRingCount() : 0;
    }

    startEdit() {
        this.removeInteractions();
        if (!this.buttonsGroupActive) {
            this.toggleButtonsOn();
            return;
        } else {
            this.toggleButtonsOff(this.btnEdit);
        }

        this.select = new this.ol.interaction.Select({
            layers: [this.edit],
            style: (feature) => this.measureStyle(feature),
        });

        this.modify = new this.ol.interaction.Modify({
            source: this.edit.getSource(),
        });

        this.snap = new this.ol.interaction.Snap({
            source: this.edit.getSource(),
        });

        this.map.addInteraction(this.select);
        this.map.addInteraction(this.modify);
        this.map.addInteraction(this.snap);
        this.modify.on('modifystart', (feature) => this.onModifyStart(feature));
        this.modify.on('modifyend', (feature) => this.onModifyEnd(feature));
    }
    onModifyStart(feature) {
        this.editCountBeforeDraw = 0;
        const features = feature.features.getArray();
        this.editFeatures = [];
        for (const feat of features) {
            this.editFeatures.push(feat.clone());
        }
    }
    onModifyEnd(feature) {
        const features = feature.features.getArray();
        this.addToFeatures(features);

        const event = new CustomEvent('qmolModify', {
            detail: {
                features: new this.ol.format.GeoJSON().writeFeaturesObject(features, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: 'EPSG:3857',
                }),
                type: 'modify',
            },
        });
        document.dispatchEvent(event);
    }

    startDelete() {
        this.removeInteractions();
        if (!this.buttonsGroupActive) {
            this.toggleButtonsOn();
            return;
        } else {
            this.toggleButtonsOff(this.btnDelete);
        }

        this.select = new this.ol.interaction.Select({
            layers: [this.edit],
            style: (feature) => this.measureStyle(feature),
        });

        this.map.addInteraction(this.select);
        this.select.on('select', (selected) => this.onEndDelete(selected));
    }
    onEndDelete(selected) {
        let features = [];
        for (const feature of selected.selected) {
            features.push(feature.clone());
            this.edit.getSource().removeFeature(feature);
        }

        const event = new CustomEvent('qmolDelete', {
            detail: {
                features: new this.ol.format.GeoJSON().writeFeaturesObject(features, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: 'EPSG:3857',
                }),
                type: 'delete',
            },
        });
        document.dispatchEvent(event);
    }

    startIdentify() {
        if (!this.buttonsGroupActive) {
            this.toggleButtonsOn();
            return;
        } else {
            this.toggleButtonsOff(this.btnIdentify);
        }
    }

    startWeather() {
        if (!this.buttonsGroupActive) {
            this.toggleButtonsOn();
            this.divPopup.style.display = 'none';
            return;
        } else {
            this.toggleButtonsOff(this.btnWeather);
        }
    }

    startBullseye() {
        if (!this.buttonsGroupActive) {
            this.toggleButtonsOn();
            return;
        } else {
            this.toggleButtonsOff(this.btnBullseye);
            this.bullseye.getSource().clear();
        }
    }

    clearBullseye() {
        this.bullseye.getSource().clear();
    }

    onSingleClick(evt) {
        if (!this.buttonsGroupActive && (!this.btnDraw.disabled || !this.btnEdit.disabled || !this.btnDelete.disabled || !this.btnMeasure.disabled)) {
            return;
        }

        const coordinate = this.ol.proj.toLonLat(evt.coordinate);
        const latlong = document.getElementsByClassName('ol-latlong')[0];
        latlong.innerHTML = (Math.round(coordinate[0] * 100000) / 100000).toFixed(5) + ', ' + (Math.round(coordinate[1] * 100000) / 100000).toFixed(5);

        if (!this.buttonsGroupActive && !this.btnWeather.disabled) {
            this.getWeather(evt.coordinate, coordinate);
            return;
        }
        if (!this.buttonsGroupActive && !this.btnBullseye.disabled) {
            this.drawBullseye(evt.coordinate);
            return;
        }

        let clickFor = 'click';
        if (!this.buttonsGroupActive && !this.btnIdentify.disabled) clickFor = 'identify';

        const features = [];
        this.map.forEachFeatureAtPixel(
            evt.pixel,
            function (feature, layer) {
                feature.setProperties({ layer: layer.get('name') });
                features.push(feature);
            },
            {
                hitTolerance: 10,
            }
        );

        const stateCounty = this.getCountyForLongLat([coordinate[0], coordinate[1]]);

        const event = new CustomEvent('qmolSingleClick', {
            detail: {
                stateCounty: stateCounty,
                coordinate: coordinate,
                features: new this.ol.format.GeoJSON().writeFeaturesObject(features, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: 'EPSG:3857',
                }),
                type: clickFor,
            },
        });
        document.dispatchEvent(event);
    }

    dispatchEvent(eventName, detail) {
        document.dispatchEvent(new CustomEvent(eventName, { detail }));
    }

    removeInteractions() {
        this.map.removeInteraction(this.draw);
        this.map.removeInteraction(this.modify);
        this.map.removeInteraction(this.snap);
        this.map.removeInteraction(this.select);
    }

    measureStyle(feature) {
        let styles = [
            new this.ol.style.Style({
                fill: new this.ol.style.Fill({
                    color: 'rgba(255,255,255,0.5)',
                }),
                stroke: new this.ol.style.Stroke({
                    color: 'white',
                    width: 3,
                }),
            }),
            new this.ol.style.Style({
                stroke: new this.ol.style.Stroke({
                    color: 'black',
                    lineDash: [10, 10],
                    width: 3,
                }),
            }),
            new this.ol.style.Style({
                image: new this.ol.style.Circle({
                    radius: 5,
                    fill: new this.ol.style.Fill({
                        color: 'white',
                    }),
                    stroke: new this.ol.style.Stroke({
                        color: 'black',
                        width: 2,
                    }),
                }),
            }),
        ];

        const geometry = feature.getGeometry();
        if (geometry.getType() === 'Point') return styles;

        let segmentStyles = [];
        let count = 0;
        let line;
        if (geometry.getType() === 'Polygon') {
            line = new this.ol.geom.LineString(geometry.getCoordinates()[0]);
        } else {
            line = geometry;
        }
        line.forEachSegment((a, b) => {
            const segment = new this.ol.geom.LineString([a, b]);
            let label = `${this.getDirection(segment)} ${this.formatLength(segment)}`;
            if (segmentStyles.length - 1 < count) {
                segmentStyles.push(
                    new this.ol.style.Style({
                        text: new this.ol.style.Text({
                            text: '',
                            font: 'bold 12px Calibri,sans-serif',
                            stroke: new this.ol.style.Stroke({
                                color: [255, 255, 255, 1],
                                width: 3,
                            }),
                            fill: new this.ol.style.Fill({
                                color: [[0, 0, 0, 1]],
                            }),
                            offsetY: 0,
                        }),
                    })
                );
            }
            const segmentPoint = new this.ol.geom.Point(segment.getCoordinateAt(0.5));
            segmentStyles[count].setGeometry(segmentPoint);
            segmentStyles[count].getText().setText(label);
            styles.push(segmentStyles[count]);
            count++;
            segmentStyles.push(
                new this.ol.style.Style({
                    image: new this.ol.style.Circle({
                        radius: 5,
                        stroke: new this.ol.style.Stroke({
                            color: 'black',
                            width: 2,
                        }),
                        fill: new this.ol.style.Fill({
                            color: 'white',
                        }),
                    }),
                })
            );
            segmentStyles[count].setGeometry(new this.ol.geom.Point(segment.getFirstCoordinate()));
            styles.push(segmentStyles[count]);
            count++;
        });

        if (geometry.getType() === 'LineString') {
            const total = new this.ol.style.Style({
                text: new this.ol.style.Text({
                    text: '',
                    font: 'bold 12px Calibri,sans-serif',
                    stroke: new this.ol.style.Stroke({
                        color: 'white',
                        width: 3,
                    }),
                    fill: new this.ol.style.Fill({
                        color: 'red',
                    }),
                    offsetY: -15,
                }),
                image: new this.ol.style.Circle({
                    radius: 5,
                    stroke: new this.ol.style.Stroke({
                        color: 'black',
                        width: 2,
                    }),
                    fill: new this.ol.style.Fill({
                        color: 'white',
                    }),
                }),
            });
            total.setGeometry(new this.ol.geom.Point(geometry.getLastCoordinate()));
            total.getText().setText(`${this.getDirection(geometry)}${this.formatLength(geometry)}`);
            styles.push(total);
        } else if (geometry.getType() === 'Polygon' && geometry.getCoordinates()[0].length > 3) {
            const total = new this.ol.style.Style({
                text: new this.ol.style.Text({
                    text: '',
                    font: 'bold 12px Calibri,sans-serif',
                    stroke: new this.ol.style.Stroke({
                        color: 'white',
                        width: 3,
                    }),
                    fill: new this.ol.style.Fill({
                        color: 'blue',
                    }),
                    offsetY: -15,
                }),
            });
            total.setGeometry(geometry.getInteriorPoint());
            total.getText().setText(this.formatArea(geometry));
            styles.push(total);
        }

        return styles;
    }

    getDirection(geometry) {
        if (geometry.getType() === 'LineString') {
            const coords = geometry.getCoordinates();
            if (coords.length > 1) {
                const point1 = this.ol.proj.toLonLat(coords[coords.length - 2]);
                const point2 = this.ol.proj.toLonLat(coords[coords.length - 1]);
                var dx = point2[0] - point1[0];
                var dy = point2[1] - point1[1];
                var angle = Math.atan2(dy, dx);
                var degrees = (angle * 180) / Math.PI;
                if (degrees >= 0 && degrees < 22.5) {
                    return 'E ';
                }
                if (degrees >= 22.5 && degrees < 67.5) {
                    return 'NE ';
                }
                if (degrees >= 67.5 && degrees < 112.5) {
                    return 'N ';
                }
                if (degrees >= 112.5 && degrees < 157.5) {
                    return 'NW ';
                }
                if (degrees >= 157.5 && degrees <= 180) {
                    return 'W ';
                }
                if (degrees < 0 && degrees > -22.5) {
                    return 'E ';
                }
                if (degrees <= -22.5 && degrees > -67.5) {
                    return 'SE ';
                }
                if (degrees <= -67.5 && degrees > -112.5) {
                    return 'S ';
                }
                if (degrees <= -112.5 && degrees > -157.5) {
                    return 'SW ';
                }
                if (degrees <= -157.5 && degrees >= -180) {
                    return 'W ';
                }
            }
        }
    }

    formatLength(line) {
        const length = this.ol.sphere.getLength(line) * 3.28084;
        var output;
        if (length > 5280) {
            output = (Math.round((length / 5280) * 10) / 10).toLocaleString('en-US') + ' ' + 'mi';
        } else {
            output = Math.round(length).toLocaleString('en-US') + ' ' + 'ft';
        }
        return output;
    }

    formatArea = function (polygon) {
        const area = this.ol.sphere.getArea(polygon) * 10.7639;
        let output;
        if (area > 2787840) {
            output = (Math.round((area / 27878400) * 100) / 100).toLocaleString('en-US') + ' mi\xB2';
        } else {
            output = Math.round(area).toLocaleString('en-US') + ' ft\xB2';
        }
        return output;
    };

    getFipsForFeature(feature) {
        let fips = [];
        let featureExtent;
        if (feature.getGeometry().getType() !== 'Point') {
            featureExtent = new this.ol.geom.Polygon(feature.getGeometry().getCoordinates()).getExtent();
        } else {
            const coords = feature.getGeometry().getCoordinates();
            featureExtent = [coords[0] - 0.000001, coords[1] - 0.000001, coords[0] + 0.000001, coords[1] + 0.000001];
        }
        for (const county of this.counties) {
            const countyPolygon = new this.ol.geom.Polygon(county.getGeometry().getCoordinates());
            if (countyPolygon.intersectsExtent(featureExtent)) {
                fips.push(county.getProperties().STCO);
            }
        }
        return fips;
    }

    addToEdit(features) {
        if (features.features.length === 0) return;
        this.edit.getSource().addFeatures(
            new this.ol.format.GeoJSON().readFeatures(features, {
                featureProjection: 'EPSG:3857',
            })
        );
    }

    getFromEdit() {
        return new this.ol.format.GeoJSON().writeFeatures(this.edit.getSource().getFeatures(), {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });
    }

    removeFromEdit(property, value) {
        for (const feature of this.edit.getSource().getFeatures()) {
            if (feature.get(property) === value) {
                this.show.getSource().removeFeature(feature);
            }
        }
    }

    zoomToEdit() {
        if (this.edit.getSource().getFeatures().length === 0) return;
        this.map.getView().fit(this.edit.getSource().getExtent(), {
            padding: [50, 50, 50, 50],
        });
        this.getNewtin();
        if (this.map.getView().getZoom() > this.maxzoom) {
            this.map.getView().setZoom(this.maxzoom);
        }
    }

    clearEdit() {
        this.edit.getSource().clear();
    }

    async getWeather(evtCoordinate, coordinate) {
        /* prettier-ignore */
        let retry = 0;
        const response = await fetch(`https://api.weather.gov/points/${(Math.round(coordinate[1] * 100000) / 100000).toFixed(4)},${(Math.round(coordinate[0] * 100000) / 100000).toFixed(4)}`);
        const grid = await response.json();
        function getTempColor(period) {
            const color = period.isDaytime ? '#FF0000' : '#0000FF';
            return `<span style="color:${color}">${period.temperature}&deg;</span>`;
        }
        if (grid.properties) {
            do {
                const response = await fetch(`${grid.properties.forecast}`);
                const forecast = await response.json();
                if (forecast && forecast.properties) {
                    this.divPopup.innerHTML = `
                                <div>
                                    <table cellspacing="0" cellpadding="0" class="weather-table">
                                        <tr><td><b>${forecast.properties.periods[0].name} ${getTempColor(forecast.properties.periods[0])}</b></td><td><b>${forecast.properties.periods[1].name} ${getTempColor(forecast.properties.periods[1])}</b></td><td><b>${forecast.properties.periods[2].name} ${getTempColor(forecast.properties.periods[2])}</b></td></tr>
                                        <tr><td><img src="${forecast.properties.periods[0].icon}"></td><td><img src="${forecast.properties.periods[1].icon}"></td><td><img src="${forecast.properties.periods[2].icon}"></td></tr>
                                        <tr><td>${forecast.properties.periods[0].shortForecast}</td><td>${forecast.properties.periods[1].shortForecast}</td><td>${forecast.properties.periods[2].shortForecast}</td></tr>
                                    </table>
                                </div>
                            `;
                    this.divPopupOverlay.setPosition(evtCoordinate);
                    this.divPopup.style.display = 'block';
                    return;
                }
                await new Promise((r) => setTimeout(r, 100));
            } while (retry++ < 5);
        }
    }

    drawBullseye(coordinate) {
        const point = new this.ol.geom.Point(coordinate);

        let feature = new this.ol.Feature({
            geometry: point,
        });

        this.drawBullseyeRing(feature, 3);
        for (var i = 100; i <= 1000; i += 100) {
            this.drawBullseyeRing(feature, i);
        }
        this.drawBullseyeRing(feature, 1320);
    }
    drawBullseyeRing(feature, bufferSize) {
        let ring = this.bufferFeature(feature, bufferSize, 16);
        let color;
        if (bufferSize === 500 || bufferSize === 1000) {
            color = [255, 0, 0, 1];
        } else {
            color = [0, 0, 0, 1];
        }

        ring.setStyle(
            new this.ol.style.Style({
                stroke: new this.ol.style.Stroke({
                    color: color,
                    width: 2,
                }),
            })
        );
        this.bullseye.getSource().addFeature(ring);
    }

    mergeFeatures(source) {
        for (const feature of source.getFeatures()) {
            if (feature.getGeometry().getType() !== 'Polygon') {
                this.bufferFeature(feature, this.drawBuffer);
            }
        }

        let merged = true;
        if (source.getFeatures().length > 1) {
            const format = new this.ol.format.GeoJSON();
            for (var i = 0; i < source.getFeatures().length; i++) {
                const first = source.getFeatures()[i];
                var firstClone = source.getFeatures()[i].clone();
                for (var j = source.getFeatures().length - 1; j >= 1; j--) {
                    const second = source.getFeatures()[j];
                    var secondClone = source.getFeatures()[j].clone();
                    const firstGeoJson = format.writeFeatureObject(firstClone);
                    const secondGeoJson = format.writeFeatureObject(secondClone);
                    if (this.turf.booleanIntersects(firstGeoJson, secondGeoJson)) {
                        var union = this.turf.union(firstGeoJson, secondGeoJson);
                        union = format.readFeature(union);
                        first.setGeometry(union.getGeometry());
                        source.removeFeature(second);
                    } else {
                        merged = false;
                    }
                }
            }
        }
        return merged;
    }

    addToImage(imageUrl, extentLonMinLatMinLonMaxLatMax, projection = 'EPSG:4326') {
        this.image.setExtent(this.ol.proj.transformExtent(extentLonMinLatMinLonMaxLatMax, 'EPSG:4326', 'EPSG:3857'));
        this.image.setSource(
            new this.ol.source.ImageStatic({
                url: imageUrl,
                imageExtent: extentLonMinLatMinLonMaxLatMax,
                projection: projection,
                crossOrigin: 'anonymous',
            })
        );
    }

    zoomToImage() {
        this.map.getView().fit(this.image.getExtent());
    }

    clearImage() {
        this.image.setSource(null);
    }

    getMapExtent() {
        return this.ol.proj.transformExtent(this.map.getView().calculateExtent(this.map.getSize()), 'EPSG:3857', 'EPSG:4326');
    }

    getMapExtentObj() {
        const extent = this.ol.proj.transformExtent(this.map.getView().calculateExtent(this.map.getSize()), 'EPSG:3857', 'EPSG:4326');
        return {
            left: extent[0],
            bottom: extent[1],
            right: extent[2],
            top: extent[3],
        };
    }

    getMapZoom() {
        return this.map.getView().getZoom();
    }

    showCounty(st, cnty) {
        this.removeFromShow('group', 'counties');
        for (const county of this.counties) {
            if (county.get('STATE') === st && (!cnty || county.get('COUNTY').toUpperCase() === cnty.toUpperCase())) {
                const feature = county.clone();
                feature.setProperties({
                    group: 'counties',
                });
                feature.setStyle(
                    new this.ol.style.Style({
                        text: new this.ol.style.Text({ text: feature.get('COUNTY'), font: 'bold 14px Calibri,sans-serif', stroke: new this.ol.style.Stroke({ color: 'white', width: 3 }), fill: new this.ol.style.Fill({ color: 'black' }) }),
                        stroke: new this.ol.style.Stroke({ color: 'gray', width: 2 }),
                    })
                );
                this.show.getSource().addFeature(feature);
            }
        }
    }

    onRotationReset() {
        this.compassDegrees = 0;
        document.getElementsByClassName('ol-compass')[1].style.transform = `rotate(0rad)`;
        this.map.getView().setRotation(0);
    }

    onRotationIncrement() {
        this.compassDegrees += 15;
        const rad = (this.compassDegrees * Math.PI) / 180;
        document.getElementsByClassName('ol-compass')[1].style.transform = `rotate(${rad}rad)`;
        this.map.getView().setRotation(rad);
    }
}

if (typeof module === 'object') {
    module.exports = {
        quickMap,
    };
}
